/* eslint-disable @typescript-eslint/explicit-function-return-type */
import type {Routes} from "@angular/router";
import {UserAccountType} from "../../models/users/User";
import {hasUserTypes, isLoggedIn} from "../../services/guards/permission-guard";

export const timeEntryRoutes = [
  {
    path: "time-entries",
    canActivateChild: [
      isLoggedIn,
      hasUserTypes(UserAccountType.Admin, UserAccountType.Bactoforce),
    ],
    children: [
      {
        path: "",
        loadComponent: () => import("./list/time-entries-list").then(m => m.TimeEntriesList),
      },
      {
        path: "create",
        loadComponent: () => import("./form/time-entry-form").then(m => m.TimeEntryForm),
      },
      {
        path: ":timeEntryId",
        loadComponent: () => import("./form/time-entry-form").then(m => m.TimeEntryForm),
      },
    ],
  },
] as const satisfies Routes;
